// extracted by mini-css-extract-plugin
export var blueGhost = "asLo0B6VSWy7jRT_EwCA l_MoOvECU4zRHpefnGSG";
export var blueUnderlined = "l_MoOvECU4zRHpefnGSG";
export var colourInherit = "Qol23nGE4FFaCq3qXABp";
export var focusVisible = "VA1TSinQ5V83pqnvYREK";
export var icon = "NGZVXmZXz7l2zsKy5dB1";
export var root = "xI_VlvGa8Gs7DsaeIogt";